<template>
  <div class="tw:py-4 tw:px-6 tw:flex tw:flex-col tw:gap-2.5 tw:bg-default-000 tw:border-t tw:border-default-200">
    <p class="tw:body-1">{{ translation.header }}</p>
    <div class="tw:flex tw:justify-between">
      <p class="tw:heading-3">{{ translation.billedContacts }}</p>
      <p class="tw:heading-3">{{ billedContactsCount }}</p>
    </div>
    <div class="tw:flex tw:justify-between">
      <p class="tw:body-2--bold tw:text-default-700">{{ translation.maxContacts }}</p>
      <p class="tw:body-2--bold tw:text-default-700">
        {{ translation.upTo.replace("{contacts}", plan?.upToUnits?.toString() || "--") }}
      </p>
    </div>
    <hr />
    <div class="tw:flex tw:justify-between">
      <p class="tw:heading-3">{{ translation.monthlyPayment }}</p>
      <!-- In Brazil, the final price already includes all taxes, so there’s no need to show "+ VAT". -->
      <p class="tw:heading-3">{{ planPrice }} {{ isBrazil ? currency : `${currency} + VAT` }}</p>
    </div>
    <EdroneAlert type="info" :desc="translation.helper">
      <template #custom-icon>
        <font-awesome-icon icon="fa-light fa-info-circle" />
      </template>
    </EdroneAlert>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useFreemiumStore, Customers } from "vue-app/components/Freemium/Freemium.store.ts";
import { storeToRefs } from "pinia";
import { COUNTRY_ID } from "vue-app/types/enums.ts";
import EdroneAlert from "edrone-components/EdroneAlert.vue";

const store = useFreemiumStore();
const { customersCount, recommendedCustomersCount, selectedContacts, selectedCustomersOption } = storeToRefs(store);

const translation = window._trans._freemium.upgradeDrawer.summary;

const isBrazil = window.EDRONE_CONTEXT.tracker.countryId === COUNTRY_ID.BRAZIL;

function resolveCurrency(countryId: number) {
  if (!countryId || countryId === COUNTRY_ID.POLAND) return "PLN";
  if (countryId === COUNTRY_ID.BRAZIL) return "BRL";
  return "EUR";
}

const currency = resolveCurrency(window.EDRONE_CONTEXT.tracker.countryId);

const billedContactsCount = computed(() => {
  if (selectedCustomersOption.value === Customers.Manual) {
    return selectedContacts.value;
  }
  if (selectedCustomersOption.value === Customers.Recommended) {
    return recommendedCustomersCount.value;
  }
  return customersCount.value;
});

const plan = computed(() => {
  return store.getPlan(billedContactsCount.value);
});

const planPrice = computed(() => {
  return plan.value?.price || 0;
});
</script>
